if (!customElements.get('mc-featured-reviews')) {
  customElements.define('mc-featured-reviews', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.start());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      this.events?.abort();
    }
    start() {
      this.events?.abort();
      this.track = this.querySelector('[data-fr-track]');
      this.cards = Array.from(this.querySelectorAll('[data-fr-card]'));
      if (!this.track || !this.cards.length) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
        const current = this.currentIndex();
        const destinations = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: this.cards.length - 1 };
        if (!(event.key in destinations)) return;
        event.preventDefault();
        this.move(destinations[event.key]);
      }, options);
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        event.preventDefault();
        this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft };
        this.track.setPointerCapture(event.pointerId);
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const distance = event.clientX - this.drag.x;
        if (Math.abs(distance) > 4) this.track.setAttribute('data-fr-dragging', '');
        if (this.track.hasAttribute('data-fr-dragging')) this.track.scrollLeft = this.drag.left - distance;
      }, options);
      const finishDrag = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        this.drag = null;
        const moved = this.track.hasAttribute('data-fr-dragging');
        this.track.removeAttribute('data-fr-dragging');
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        if (moved) this.move(this.currentIndex());
      };
      this.track.addEventListener('pointerup', finishDrag, options);
      this.track.addEventListener('pointercancel', finishDrag, options);
      this.track.addEventListener('lostpointercapture', finishDrag, options);
    }
    currentIndex() {
      const step = this.cards.length > 1 ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : 1;
      return Math.max(0, Math.min(this.cards.length - 1, Math.round(this.track.scrollLeft / step)));
    }
    move(index) {
      const target = Math.max(0, Math.min(this.cards.length - 1, index));
      this.track.scrollTo({
        left: this.cards[target].offsetLeft - this.cards[0].offsetLeft,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  });
}
